<template>
  <div class="syounin_users" v-if="options && syouninGroupDetail">
    <div class="maininfo">
      <div>
        <p>変更する承認グループの承認者・確認者を選択して下さい</p>
      </div>
    </div>

    <div style="display:flex">
      <div class="container">

      <section>
        <div class="item-container">
          <label>
            <p class="optional">承認者・確認者リスト</p>
          </label>
        </div>
        <div class="item-container">
          <div class="selectedFacility">
            <scroll-table max-height="calc(70vh - 190px)">
              <table>
                <thead>
                  <tr>
                    <th>承認順序</th>
                    <th>ユーザー名</th>
                    <th>承認者・確認者</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in syouninGroupDetail.syounin_users" :key="row.user_id">
                    <template v-if="row.is_syounin">
                      <td class="bureau">
                        {{ row.syounin_order }}

                        <template v-if="row.is_syounin">
                          <template v-if="index === 0">
                          </template>
                          <template v-else>
                            <button type="button" class="btn primary" @click="swapSyouninOrder(index)">
                              <i class="fa-solid fa-arrow-down-up-across-line"></i>
                            </button>
                          </template>
                        </template>
                      </td>
                    </template>
                    <template v-else>
                      <td></td>
                    </template>
                    <td class="office">{{ row.staff_name }}</td>
                    <td>
                      <input-radio :options="radioOptions" v-model="row.is_syounin"
                        @update="updateIsSyounin(index)"></input-radio>
                    </td>
                    <td class="delete">
                      <button type="button" class="btn danger" v-on:click="removeSelectUser(row)">削除</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </scroll-table>
          </div>
        </div>
      </section>

        <div>
          <p class="btn-temporary-save">
            <button type="button" @click="updateSyounin" :disabled="isUpdating">
              <template v-if="isUpdating">
                <i class="fa-solid fa-spinner fa-spin-pulse"></i>承認者・確認者を更新中…
              </template>
              <template v-else>
                <i class="fa-solid fa-floppy-disk"></i>承認順序、承認者・確認者の種別を変更します
              </template>
            </button>
          </p>
        </div>


      </div>

      <p class="btn-temporary-save">
        <button type="button" @click="pushSyouninUsers" :disabled="selectItemCount === 0 || isAdding">
          <template v-if="isAdding">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>承認者・確認者を更新中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>承認者・確認者を追加します
          </template>
        </button>
      </p>

      <div class="container">
        <section>
        <div class="facility-search">
          <div class="search-container">
            <div class="item-container">
              <label>
                <!-- <b class="optional">検索条件：仮：検討中。現在は全ユーザーを取得</b> -->
                <!-- <input-text v-model="searchCondition" type="text"></input-text> -->
              </label>
            </div>

            <div class="filter">
                  <label>検索した結果をユーザー名でフィルターします：</label>
                  <input v-model="filterCondition" type="text">
            </div>

            <div class="item-container">
              <label>
                <p class="required">ユーザーを検索します。</p>
              </label>
            </div>

            <div class="btn-container">
              <button type="button" class="btn primary" @click="search"><i
                  class="fa-solid fa-magnifying-glass"></i>検索</button>
            </div>
          </div>

          <div class="search-result" v-if="selectableSyouninUserList.length">
            <scroll-table max-height="calc(70vh - 340px)">
              <table>
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>社員番号</th>
                    <th>ユーザー名</th>
                    <th>承認者・確認者</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in filteredUsers" :key="index">
                    <td class="delete"><input-checkbox :options="OptionConst.NO_LABEL" v-model="row.is_select"
                        :disabled="row.active"></input-checkbox></td>
                    <td>{{ row.staff_code }}</td>
                    <td>{{ row.staff_name }}</td>
                    <td>
                      <input-radio :options="radioOptions" v-model="row.is_syounin"></input-radio>
                    </td>
                  </tr>
                </tbody>
              </table>
            </scroll-table>
          </div>
        </div>
        </section>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';
import { SyouninGroupDetail, SyouninGroupOptions, SyouninUser } from "@/types/SyouninGroup";
import OptionConst from '@/const/Option';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';

export default defineComponent({
  props: {
    syouninGroupDetail: {
      type: Object as () => SyouninGroupDetail | null,
      default: null
    },
    options: {
      type: Object as () => SyouninGroupOptions | null,
      default: null
    }
  },
  emits: {
    reload() {
      return true
    }
  },
  setup(props, context) {

    // 承認グループの承認者として登録するユーザーを検索
    const { selectableSyouninUserList, getSelectableSyouninUserList, deleteSyouninUser, isAdding, addSyouninUser, isUpdating, updateSyouninUsers } = useSyouninGroup()

    // 承認者・確認者のラジオオプション
    const radioOptions = [{ 'val': true, 'label': '承認者' }, { 'val': false, 'label': '確認のみ' }];

    // フィルタ変数
    const filter = ref('')

    let filterCondition = ref('');

    // ユーザーを検索します
    const search = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      await getSelectableSyouninUserList(props.syouninGroupDetail.mst_syounin_group_id);
    };

    const filteredUsers = computed(() => {
      if (filterCondition.value) {
        return selectableSyouninUserList.value.filter(user => user.staff_name.match(filterCondition.value))
      } else {
        return selectableSyouninUserList.value
      }
    })

    // 承認者リストへ追加します
    const pushSyouninUsers = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      let mstSyouninGroupId = props.syouninGroupDetail.mst_syounin_group_id;
      let selectedUserList = selectableSyouninUserList.value.filter((v) => v.is_select);

      await addSyouninUser(mstSyouninGroupId, selectedUserList)
      context.emit('reload')
    };

    // 選択したユーザーの行数を返す(検索結果)
    const selectItemCount = computed(() => {
      const selectItems = selectableSyouninUserList.value.filter((v) => v.is_select);
      return selectItems.length;
    });

    // 承認者・確認者を切り替え時、承認順序を消す
    const updateIsSyounin = (idx: number) => {
      if (!props.syouninGroupDetail) {
        return
      }
      if (!props.syouninGroupDetail.syounin_users) {
        return
      }
      let syouninUserList = props.syouninGroupDetail.syounin_users;
      if (!syouninUserList[idx].is_syounin) {
        syouninUserList[idx].syounin_order = null;
      }
    }

    // 承認順位を交換する
    const swapSyouninOrder = async (idx: number) => {
      if (idx === 0) {
        return
      }
      if (!props.syouninGroupDetail) {
        return
      }

      if (!props.syouninGroupDetail.syounin_users) {
        return
      }

      let syouninUserList = props.syouninGroupDetail.syounin_users
      let tmpArray = syouninUserList.splice(idx, 1)
      syouninUserList.splice(idx - 1, 0, tmpArray[0])

      await setSyouninOrder(syouninUserList)      
      // context.emit('reload')
    }

    // 承認順位を設定する
    const setSyouninOrder = async (syouninUserList: SyouninUser[]) => {
      let count = 1
      syouninUserList.forEach((el) => {
        if (el.is_syounin) {
          el.syounin_order = count++
        }
      });
    }

    // 承認順位を更新する
    const updateSyounin = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      if (!props.syouninGroupDetail.syounin_users) {
        return
      }
      let syouninUserList = props.syouninGroupDetail.syounin_users;
      setSyouninOrder(syouninUserList);
      let tmpSyounin = syouninUserList.filter((v: any) => v.is_syounin);
      let tmpKakunin = syouninUserList.filter((v: any) => v.is_syounin === false);

      const all = tmpSyounin.concat(tmpKakunin);
      // 既に追加されているもの(重複)は排除する
      props.syouninGroupDetail.syounin_users = [...new Map(all.map((o: any) => [o.user_id, o])).values()];

      await updateSyouninUsers(props.syouninGroupDetail)      
      context.emit('reload')
    };

    // 承認者リストからユーザーを削除します
    const removeSelectUser = async (user: SyouninUser) => {
      if (!props.syouninGroupDetail) {
        return
      }
      if (!props.syouninGroupDetail.syounin_users) {
        return
      }
      await deleteSyouninUser(user)      
      context.emit('reload')
    };

    return {
      OptionConst,
      radioOptions,
      filter,
      // 承認者・確認者検索
      search,
      selectableSyouninUserList,
      // 承認者・確認者追加
      pushSyouninUsers,
      selectItemCount,
      isAdding,
      addSyouninUser,
      // 承認順序の変更
      updateIsSyounin,
      swapSyouninOrder,
      setSyouninOrder,
      updateSyounin,
      isUpdating,
      updateSyouninUsers,
      // 承認者・確認者削除
      removeSelectUser,
      deleteSyouninUser,
      filterCondition,
      filteredUsers,
    }
  },
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syounin_group_edit.scss";
</style>
